import { ref } from 'vue';

const errorMessage = ref<string | null>(null);
const errorDetails = ref<string | null>(null);
const modelValue = ref(false);

export function showError(message: string, details: string | null = null) {
    errorMessage.value = message;
    errorDetails.value = details;
    modelValue.value = true;
}

export function useErrorModal() {
    return {
        errorMessage,
        errorDetails,
        modelValue,
    };
}